export default {
  app: {
    ru: {
      'app.name': 'Traffers',
      'app.tagline': 'Автоотклики на вакансии hh.ru',
    }
  }
};
